function createRandomChar(nums) {
	const charsMap = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
	let randomChar = ''
	for(let i = 0;i < nums;i++) {
		randomChar = randomChar + charsMap[Math.floor(Math.random() * 26)]
	}
	return randomChar
}

export function createTicketByMj() {
	return new Promise((resolve, reject) => {
		(function (a, b) {
			window['_mjObject'] = b
			window[b] = window[b] || function () {
				(window[b].q = window[b].q || []).push(arguments)
			}
			var c = document.createElement('script')
			var d = document.getElementsByTagName('script')[0]
			c.async = true
			c.src = a
			d.parentNode.insertBefore(c, d)

			c.onload = () => {
				// resolve('加载完毕')
				window.mj('set_params', {
					url: 'https://ng-linking.yunjiglobal.com/jta/event', // 事件发送地址
					tid: 'yunjiglobal', // 绑定在平台上的 API key
					user_id : "huaxi"
				})

				window.mj('activation', {
					tick: String(new Date().getTime()) + createRandomChar(4)
				}, function(status, data) {
					resolve(data)
				})
			}
		})('https://static.yunjiglobal.com/qnUpload/frontend/mjsdk-1.4.4.min.js', 'mj')
	})
}
